module.exports = __webpack_public_path__ + "images/bannerES-3ffebda9b6a56f35eb44a31c77ccbd63.jpg";